module.exports = __webpack_public_path__ + "img/Mouseo_Kotsanas_gr.763b67da.jpg";